import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Icon } from '../../../components';
import Theme from '../../../theme';
import { InfoScreenOpened } from '../../redux/uiActions';
import { defaultScale } from '../../../utils/scaling';
import { connect } from 'react-redux';

export const InfoIconComponent = (props) => {
  return (
    <TouchableOpacity
      onPress={() => {
        props.navigation.navigate('Help');
        props.InfoScreenOpened();
      }}>
      <Icon
        size={defaultScale(25)}
        name='ios-help-circle-outline'
        style={{ color: Theme.GREY_DARK }}
      />
    </TouchableOpacity>
  );
};


mapDispatchToProps = (dispatch) => {
  return {
    InfoScreenOpened: () => dispatch(InfoScreenOpened())
  };
}

export const InfoIcon = connect(null, mapDispatchToProps)(InfoIconComponent);
